import { render, staticRenderFns } from "./HomeItem.vue?vue&type=template&id=a4f36ed2&"
import script from "./HomeItem.ts?vue&type=script&lang=ts&"
export * from "./HomeItem.ts?vue&type=script&lang=ts&"
import style0 from "./HomeItem.vue?vue&type=style&index=0&id=a4f36ed2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports